import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface OAuthApplicationRotationProps extends BaseTemplateProps {
  count: number
}

export const OAuthApplicationRotation: TemplateDefinition<OAuthApplicationRotationProps> = {
  renderParams: (props: OAuthApplicationRotationProps) => ({
    messageKey: 'notificationsDomain.templates.oAuthApplicationRotation',
    values: {
      count: props?.count,
    },
  }),
}
